export default __webpack_public_path__ + "static/media/check-icon.ce4ad054.svg";